<div class="container">

    <div style="display: block;">
        <canvas baseChart width="400" height="400"
          [type]="'line'"
          [data]="lineChartData"
          [options]="lineChartOptions"
          [legend]="lineChartLegend">
        </canvas>
      </div>
      
      
      
      <canvas baseChart
        [type]="'pie'"
        [datasets]="pieChartDatasets"
        [labels]="pieChartLabels"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"
        [legend]="pieChartLegend">
      </canvas>
      
      
      
      <canvas baseChart
              [data]="barChartData"
              [options]="barChartOptions"
              [plugins]="barChartPlugins"
              [legend]="barChartLegend"
              [type]="'bar'">
      </canvas>
      
      
      <canvas baseChart
              [labels]="doughnutChartLabels"
              [datasets]="doughnutChartDatasets"
              [options]="doughnutChartOptions"
              [legend]="true"
              [type]="'doughnut'">
      </canvas>
      
      
      
      <canvas baseChart
              [datasets]="radarChartDatasets"
              [options]="radarChartOptions"
              [labels]="radarChartLabels"
              [type]="'radar'">
      </canvas>
      
      
      
      <canvas baseChart
              [datasets]="polarAreaChartDatasets"
              [labels]="polarAreaChartLabels"
              [legend]="polarAreaLegend"
              [options]="polarAreaOptions"
              [type]="'polarArea'">
      </canvas>
      
      
      <canvas baseChart
              [datasets]="bubbleChartDatasets"
              [options]="bubbleChartOptions"
              [legend]="bubbleChartLegend"
              [type]="'bubble'">
      </canvas>
      
      
      
      
      <canvas baseChart
              [datasets]="scatterChartDatasets"
              [options]="scatterChartOptions"
              [type]="'scatter'">
      </canvas>
      
</div>